import { AxiosError } from 'axios'

// O Protheus (INFOCLIENTES) responde 400 quando a consulta roda mas nao ha o
// que devolver ("Nao foram encontrados registros...", parametro invalido,
// cliente inexistente). Qualquer outro erro -- sem resposta (link com a Capul
// fora, timeout), 5xx, 502/504 do Nginx -- e falha de conexao, e a tela deve
// avisar em vez de parecer "sem dados".
export function semDadosNoProtheus(error: unknown) {
  const status = (error as AxiosError)?.response?.status
  return status === 400 || status === 404
}
